import { findWallpaper, type WallpaperPosition } from '@/config/wallpapers';
import type { ThemeId } from './themes';

/**
 * Themes are pure CSS custom properties keyed off `<html data-theme>`, so
 * switching one is a single attribute write with no re-render.
 */
export function applyTheme(id: ThemeId): void {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', id);
}

const POSITION_STYLES: Record<WallpaperPosition, { size: string; repeat: string; position: string }> = {
  stretch: { size: 'cover', repeat: 'no-repeat', position: 'center center' },
  center: { size: 'auto', repeat: 'no-repeat', position: 'center center' },
  tile: { size: 'auto', repeat: 'repeat', position: 'top left' },
};

export interface WallpaperStyle {
  backgroundColor: string;
  backgroundImage?: string;
  backgroundSize?: string;
  backgroundRepeat?: string;
  backgroundPosition?: string;
}

/** Inline style for the desktop's wallpaper layer. */
export function wallpaperStyle(id: string, position: WallpaperPosition): WallpaperStyle {
  const wp = findWallpaper(id);
  if (!wp.src) return { backgroundColor: wp.backdrop };
  const p = POSITION_STYLES[position];
  return {
    backgroundColor: wp.backdrop,
    backgroundImage: `url("${wp.src}")`,
    backgroundSize: p.size,
    backgroundRepeat: p.repeat,
    backgroundPosition: p.position,
  };
}
